import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OktaAuthOptions } from '@okta/okta-auth-js';
import { lastValueFrom, map } from 'rxjs';
import { Configuration } from 'src/app/core/models/configuration';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfigurationApiService {
    baseUrl: string = environment.apiUrl;
    configurationUrlSuffix = 'v1/configuration';
    private static configuration: Configuration;

    constructor(private httpClient: HttpClient) {}

    async getConfiguration() {
        await lastValueFrom(
            this.httpClient
                .get<Configuration>(`${this.baseUrl}${this.configurationUrlSuffix}?base=${window.location.host}`)
                .pipe(
                    map(data => {
                        ConfigurationApiService.configuration = data;
                    })
                )
        );
    }

    getAuthenticationSettings(): OktaAuthOptions {
        return ConfigurationApiService.configuration;
    }
}
